module.exports = __webpack_public_path__ + "static/media/tabscrolling.e5cec6e0.webp";